/**
 * The page content area, as a CSS container.
 *
 * Pages size themselves off the viewport by default, which is wrong the moment
 * anything other than the window decides how much room they get. Opening the
 * assistant takes 460px out of the page's column without the viewport moving,
 * so a `lg` breakpoint still reports a wide screen and the page renders its
 * widest layout into a space that cannot hold it.
 *
 * A named container lets a layout ask how much room IT has:
 *
 *     [`@container ${PAGE_CONTAINER} (min-width: 1000px)`]: { ... }
 *
 * Adopt it per page rather than everywhere at once. `container-type` makes an
 * element the containing block for any `position: fixed` descendant, so a page
 * with a viewport-pinned toolbar needs looking at before it is converted.
 */
export const PAGE_CONTAINER = 'page';
